// @flow @format
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import ExpandIcon from '../Icon/angle-down';
import DiskIcon from '../Icon/hdd-o';
import classNames from 'lib/classnames';
import {toSIString} from 'lib/util';
import {encodeEmail} from 'lib/cloner-api/util';
import './RepositorySelect.css';

import type {Repository} from 'lib/cloner-api';

type Props = {
	repository: Repository,
	repositories: Repository[],
	selectRepository: (repository: Repository) => void,
};

type State = {
	open: boolean,
};

class RepositorySelect extends PureComponent<Props, State> {
	_timeout: ?number;

	static propTypes = {
		repository: PropTypes.object,
		repositories: PropTypes.arrayOf(PropTypes.object),
	};

	static contextTypes = {
		router: PropTypes.object.isRequired,
	};

	state = {open: false};

	_toggleDropDown = () => this.setState(prev => ({open: !prev.open}));

	_closeDropDown = () => this.setState({open: false});

	_openDropDown = () => this.setState({open: true});

	_handleMouseLeave = () => {
		this._timeout = window.setTimeout(this._closeDropDown, 300);
	};

	_handleMouseEnter = () => {
		window.clearInterval(this._timeout);
		this._timeout = null;
	};

	_selectRepository = (repository: Repository) => {
		this.setState({open: false});
		this.context.router.replace(
			`/explorer/files/${repository.id}/${repository.root}?machineId=${repository.mid}&userId=${encodeEmail(
				repository.owner
			)}`
		);
	};

	render() {
		const {repository: currentRepository, repositories} = this.props;

		if (!currentRepository || !repositories) {
			return null; // display loading
		}

		return (
			<div
				className="RepositorySelect"
				onMouseLeave={this._handleMouseLeave}
				onMouseEnter={this._handleMouseEnter}
			>
				<div
					className="RepositorySelect__Root"
					onClick={this._toggleDropDown}
				>
					<p className="RepositorySelect__Root__Link">
						<DiskIcon className="RepositorySelect__Root__Icon" />
						{currentRepository.name}
					</p>
					<ExpandIcon className="RepositorySelect__Root__Toggle" />
				</div>

				<ul
					className={classNames({
						RepositorySelect__List: true,
						'RepositorySelect__List--Open': this.state.open,
					})}
				>
					{repositories.map(repository =>
						<li
							key={repository.id}
							className="RepositorySelect__List__Item"
							onClick={() => this._selectRepository(repository)}
						>
							<div className="RepositorySelect__List__Item__Text">
								<p className="RepositorySelect__List__Item__Name">
									<DiskIcon className="RepositorySelect__List__Item__Icon" />
									{repository.name}
								</p>
								<p className="RepositorySelect__List__Item__Status">
									{toSIString(repository.disk_space)}
								</p>
							</div>
						</li>
					)}
				</ul>
			</div>
		);
	}
}

export default RepositorySelect;



// WEBPACK FOOTER //
// ./src/components/RepositorySelect/RepositorySelect.js